import React, { useContext, useEffect, useState } from 'react'
import { LocaleContext } from 'contexts/locale'
import { useSpring, animated as a, config } from 'react-spring'
import { useInView } from 'react-intersection-observer'
import styles from './statisticsRow.module.scss'
import clsx from 'clsx'

export function StatisticsRow({
  isActive,
  text,
  value,
  color = 'var(--grey)',
  isCorrect = false
}: {
  isActive: boolean
  isCorrect: boolean
  text: string
  value: number
  color?: string
}) {
  const locale = useContext(LocaleContext)

  // Animation
  /** Check whether the browser supports IntersectionObservers */
  const IOAvailable = 'IntersectionObserver' in window
  const [ref, inView] = useInView({ threshold: 0.8 })

  /** Make sure the animation only happens once */
  const [hasAnimated, setHasAnimated] = useState(false)

  /** Once the bar has been in view, don't animate it anymore */
  useEffect(() => {
    if (inView) {
      setHasAnimated(true)
    }
  }, [inView])

  /** The actual interpolated styles */
  const horizontalBarStyles = useSpring({
    width: inView || !IOAvailable || hasAnimated ? value * 100 + '%' : '0%',
    backgroundColor: color
  })

  const percentFormat = new Intl.NumberFormat(locale + '-CH', {
    style: 'percent'
  })

  return (
    <tr ref={ref} className={clsx(isActive && 'active')}>
      <td className='collapsing'>
        <i className={clsx('green', isCorrect && 'check', 'icon')} />
      </td>
      <td>{text}</td>
      <td className='collapsing'>{percentFormat.format(value)}</td>
      <td className='eight wide'>
        <a.div className={styles.horizontalBar} style={horizontalBarStyles} />
      </td>
    </tr>
  )
}
